import Button from 'components/button/Button';
import React from 'react';
import { useDispatch } from 'react-redux';
import { signOut } from 'reducers/auth';

type Props = {};

export const BusinessVerificationComplete = (props: Props) => {
    const dispatch = useDispatch();
    return (
        <div className="Submit">
            <>
                <h1>Thank you</h1>
                <p>
                    Thank you. You have now completed your verfication. You will receive a
                    notification once the application has been reviewed.
                </p>
                <Button
                    priority="primary"
                    variety="full"
                    type="button"
                    onClick={() => dispatch(signOut())}
                >
                    Sign out
                </Button>
            </>
        </div>
    );
};
